import _ from 'lodash';
import { action } from 'mobx';

export const checkAndMergeMutable = (obj: any, key: any, value: any) => {
	const target = _.get(obj, key);
	if (typeof target === 'object' && !Array.isArray(target)) {
		return _.set(obj, key, { ...target, ...value });
	} else {
		return _.set(obj, key, value);
	}
};

export class Updater {
	@action
	public update = (n: any = {}, secondParameter?: any): void => {
		this.willUpdate(n, secondParameter);

		Object.keys(n).forEach(key => {
			if (key !== 'store' && key !== 'parent') {
				if (typeof n[key] === 'function') {
					return true;
				} else if (this[`${key}Updater`] !== undefined) {
					this[key] = this[`${key}Updater`](n[key]);
				} else {
					checkAndMergeMutable(this, key, n[key]);
				}
			}
		});

		this.didUpdate(n, secondParameter);
	};

	public willUpdate(n: any = {}, secondParameter?: any) {
		// 	'willUpdate. 업데이트 완료 후에 불러와지는 메서드. 클래스 내에서 오버라이드하여 쓴다. DB에 관한 처리나 UI에 관한 변경일 수 있다.'
		// );
	}
	public didUpdate(n: any = {}, secondParameter?: any) {
		// 	'didUpdate. 업데이트 완료 후에 불러와지는 메서드. 클래스 내에서 오버라이드하여 쓴다. DB에 관한 처리나 UI에 관한 변경일 수 있다.'
		// );
	}
}



// WEBPACK FOOTER //
// ./src/updater.ts